import { initializeApp } from 'firebase/app';
import {
  ref,
  uploadBytesResumable,
  getStorage,
  getDownloadURL,
  listAll,
  getMetadata,
  deleteObject,
} from 'firebase/storage';
import config from 'Config/Environment';

const app = initializeApp(config.firebaseConfig);

const Storage = getStorage(app);

export const uploadFile = async (route, file, setProgress = () => {}) => {
  const sotrageRef = ref(Storage, route);
  const upload = new Promise(resolve => {
    uploadBytesResumable(sotrageRef, file).on('state_changed', snapshot => {
      const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      setProgress(prog);
      if (prog === 100) {
        resolve();
      }
    });
  });
  await Promise.all([upload]);
};

export const listFiles = async path => {
  const listRef = ref(Storage, path);

  // brings a list of all the files in the google storage path
  const { items } = await listAll(listRef).catch(error => {
    // eslint-disable-next-line
    console.log(error);

    return [];
  });

  const urlPromiseArray = [];
  const metadataPromiseArray = [];
  const nameArray = [];

  items.forEach(itemRef => {
    nameArray.push(itemRef.name);

    urlPromiseArray.push(getDownloadURL(itemRef));

    metadataPromiseArray.push(getMetadata(itemRef));
  });

  const urlArray = await Promise.all(urlPromiseArray);
  const metadataArray = await Promise.all(metadataPromiseArray);

  return items.map((_, index) => ({
    fileName: nameArray[index],
    url: urlArray[index],
    metadata: metadataArray[index],
  }));
};

export const deleteFile = async path => {
  const desertRef = ref(Storage, path);
  return deleteObject(desertRef)
    .then(() => true)
    .catch(() => false);
};

export const getFile = async path => {
  const desertRef = ref(Storage, path);

  try {
    return await getDownloadURL(desertRef);
  } catch (err) {
    return null;
  }
};

export default {
  Storage: {
    uploadFile,
    listFiles,
    deleteFile,
    getFile,
  },
};
